import script from "./kalio-platanus-cal-office-hour.vue?vue&type=script&setup=true&lang=ts"
export * from "./kalio-platanus-cal-office-hour.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__